export const FinancialMetricName = {
  BurnRate: 'burn_rate',
  CashBalance: 'cash_balance',
  CashGap: 'cash_gap',
  Ebitda: 'ebitda',
  ExternalCostOfSales: 'external_cost_of_sales',
  ExternalRevenue: 'external_revenue',
  GrossProfit: 'gross_profit',
  InternalCostOfSales: 'internal_cost_of_sales',
  InternalRevenue: 'internal_revenue',
  NetIncome: 'net_income',
  NetProfit: 'net_profit',
  Opex: 'opex',
  TotalCostOfSales: 'total_cost_of_sales',
  TotalRevenue: 'total_revenue',
} as const;

export const FINANCIAL_METRIC_NAME_TO_TRANSLATION_KEY = new Map<string, string>([
  [FinancialMetricName.BurnRate, 'shared.currentPerformanceMetrics.metric.burnRate'],
  [FinancialMetricName.CashBalance, 'shared.currentPerformanceMetrics.metric.cashBalance'],
  [FinancialMetricName.CashGap, 'shared.currentPerformanceMetrics.metric.cashGap'],
  [FinancialMetricName.Ebitda, 'shared.currentPerformanceMetrics.metric.ebitda'],
  [FinancialMetricName.GrossProfit, 'shared.currentPerformanceMetrics.metric.grossProfit'],
  [FinancialMetricName.NetIncome, 'shared.currentPerformanceMetrics.metric.netIncome'],
  [FinancialMetricName.NetProfit, 'shared.currentPerformanceMetrics.metric.netProfit'],
  [FinancialMetricName.Opex, 'shared.currentPerformanceMetrics.metric.opex'],
  [FinancialMetricName.TotalCostOfSales, 'shared.currentPerformanceMetrics.metric.totalCostOfSales'],
  [
    FinancialMetricName.ExternalCostOfSales,
    'shared.currentPerformanceMetrics.metric.externalCostOfSales',
  ],
  [
    FinancialMetricName.InternalCostOfSales,
    'shared.currentPerformanceMetrics.metric.internalCostOfSales',
  ],
  [FinancialMetricName.TotalRevenue, 'shared.currentPerformanceMetrics.metric.totalRevenue'],
  [FinancialMetricName.ExternalRevenue, 'shared.currentPerformanceMetrics.metric.externalRevenue'],
  [FinancialMetricName.InternalRevenue, 'shared.currentPerformanceMetrics.metric.internalRevenue'],
]);
